@if (items$ | async; as components) {
  <div class="container d-flex border-top-bottom">
    @for (component of components; track component; let i = $index) {
      @if (component) {
        <app-custom-cms-item [item]="component"></app-custom-cms-item>
      }
    }
  </div>
}

